export default "__VITE_ASSET__d54e76d7__"